import { Label } from './ui/label';
import { useDiseaseGroups, groupName } from './volunteer/BooleanObsGroups';

function ChipSet({ title, tone, groups, selected, blocked, onToggle, lang, testid, disabled }) {
  const on = tone === 'include' ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-red-600 text-white border-red-600';
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <Label className="text-xs font-medium">{title}</Label>
      <div className="flex flex-wrap gap-1.5">
        {groups.map(g => {
          const sel = selected.includes(g.id);
          return (
            <button key={g.id} type="button" disabled={disabled || blocked.includes(g.id)} onClick={() => onToggle(g.id)}
              data-testid={`${testid}-${g.id}`}
              className={`px-2.5 py-1 rounded text-[11px] border transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${sel ? on : 'bg-white text-stone-600 border-stone-200 hover:border-stone-300 hover:bg-stone-50'}`}>
              {groupName(g, lang)}
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Incluir (tiene alguno de) / Excluir (no tiene ninguno de) grupos de enfermedad.
export function DiseaseGroupFilter({ include = [], exclude = [], onChange, lang, disabled, testidPrefix = 'disease-groups' }) {
  const groups = useDiseaseGroups().filter(g => g.active !== false || include.includes(g.id) || exclude.includes(g.id));
  const toggle = (list, id) => (list.includes(id) ? list.filter(x => x !== id) : [...list, id]);
  if (groups.length === 0) return null;
  return (
    <div className="space-y-3">
      <ChipSet title={lang === 'es' ? 'Incluir grupos de enfermedad (tiene alguno)' : 'Include disease groups (has any)'} tone="include"
        groups={groups} selected={include} blocked={exclude} lang={lang} disabled={disabled} testid={`${testidPrefix}-include`}
        onToggle={id => onChange(toggle(include, id), exclude)} />
      <ChipSet title={lang === 'es' ? 'Excluir grupos de enfermedad (no tiene ninguno)' : 'Exclude disease groups (has none)'} tone="exclude"
        groups={groups} selected={exclude} blocked={include} lang={lang} disabled={disabled} testid={`${testidPrefix}-exclude`}
        onToggle={id => onChange(include, toggle(exclude, id))} />
    </div>
  );
}
